export default function Logo({ size = 28, dark = false }) {
  const green   = "#58cc02";
  const greenDk = "#58a700";
  const word1   = dark ? "#ffffff" : "#202f36";

  return (
    <span style={{ display: "inline-flex", alignItems: "center", gap: 10 }}>
      <svg width={size + 6} height={size + 6} viewBox="0 0 64 64" fill="none" aria-hidden="true">
        {/* chunky green badge with 3D bottom edge */}
        <rect x="4" y="4" width="56" height="56" rx="16" fill={greenDk} />
        <rect x="4" y="2" width="56" height="56" rx="16" fill={green} />
        {/* white speech bubble */}
        <path d="M18 20 h28 a4 4 0 0 1 4 4 v14 a4 4 0 0 1 -4 4 h-16 l-8 7 v-7 h-4 a4 4 0 0 1 -4 -4 v-14 a4 4 0 0 1 4 -4 z"
              fill="#ffffff" />
        {/* three dots = talking */}
        <circle cx="25" cy="31" r="3" fill={green} />
        <circle cx="34" cy="31" r="3" fill={green} />
        <circle cx="43" cy="31" r="3" fill={green} />
      </svg>
      <span style={{ fontFamily: '"Baloo 2", "Nunito", sans-serif', fontWeight: 800, fontSize: size * 0.92, lineHeight: 1, color: word1, letterSpacing: "-0.01em" }}>
        Speak<span style={{ color: green }}>easy</span>
      </span>
    </span>
  );
}
